import { State } from 'xstate';

import { productCatalog } from './productCatalog';

type ProductCatalogMachine = typeof productCatalog;

type ProductCatalogState = State<ProductCatalogMachine['context']>;

export const getProductCatalogItems = (machineState: ProductCatalogState) =>
  machineState.context.items;

export const getProductCatalogById =
  (catalogId: number) => (machineState: ProductCatalogState) =>
    machineState.context.items.find(({ id }) => id === catalogId);

export const getProductCatalogFetchStatus = (
  machineState: ProductCatalogState
) => ({
  isLoading: machineState.matches('loading'),
  error: machineState.matches('error'),
  ready: machineState.matches('ready'),
});

export const getExpandedCatalogItems = (machineState: ProductCatalogState) =>
  machineState.context.expandedCatalogItems;

export const productCatalogSelectors = {
  getExpandedCatalogItems,
  getProductCatalogById,
  getProductCatalogItems,
  getProductCatalogFetchStatus,
};
